/**
 * Main page implementation.
 *
 * @author Dmytro Fedotov <d.fedotov@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageMain',
    Page          = require('stb-component-page'),
    config        = require('../config'),
    app           = require('mag-app'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    Panel         = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    Modal         = require('mag-component-modal'),
    dom           = require('spa-dom'),
    keys          = require('stb-keys'),
    ScrollBar     = require('stb-component-scrollbar'),
    Flicker       = require('spa-component-flicker'),
    ScrollArea    = require('mag-component-scroll-area'),
    Footer        = require('mag-component-footer'),
    getDeviceInfo = require('../modules/device.info'),
    $itemsCountWrapper, $itemsCount, footerButtons, leftPanelContent;


function showLogOutWarning () {
    core.notify({
        title:   gettext('Are you sure you want to log out?'),
        icon:    'alert',
        buttons: [
            {
                value: gettext('Cancel')
            },
            {
                value: gettext('Ok'),
                click: function () {
                    core.backend.logout();
                }
            }
        ]
    });
}


$itemsCountWrapper = dom.tag(
    'div',
    {className: 'amountContainer'},
    $itemsCount = dom.tag('div', {className: 'amount'}, '0')
);


page.add(
    page.clock = new Flicker({
        className: 'clock',
        interval:  1000,
        render:    function ( $item ) {
            var time  = new Date(),
                hours = time.getHours(),
                mins  = time.getMinutes();

            $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
        }
    })
);

page.clock.start();


if ( typeof core.backend.logout === 'function' ) {
    footerButtons = {
        middle: [
            {
                code:   keys.f1,
                title:  gettext('Logout'),
                action: showLogOutWarning
            }
        ]
    };

    footerButtons.left = {
        code: keys.menu,
        action: function () {
            page.panelSet.blur();
            page.modalActions.show();
        }
    };

    page.footer = new Footer({
        visible: true,
        parent: page,
        data: footerButtons
    });

    // modal message: all actions for middle list item
    page.add(
        page.modalActions = new Modal({
            visible:  false,
            title:    gettext('actions'),
            events:   {
                show: function () {
                    this.focus();
                },
                hide: function () {
                    page.middlePanel.focus();
                }
            },
            children: [
                new LayoutList({
                    cycle:      true,
                    focusIndex: 0,
                    size:       1,
                    data:       [
                        {
                            items: [
                                {className: 'theme-icon theme-icon-rc-f1', value: ''},
                                {value: gettext('Logout')}
                            ],
                            click: showLogOutWarning
                        }
                    ],
                    propagate:  true
                })
            ]
        })
    );
}


// modal message: exit
page.add(
    page.modalExit = new Modal({
        title:     gettext('Exit'),
        className: 'modalExit',
        events:    {
            show: function () {
                this.focus();
            },
            hide: function () {
                page.panelSet.focus();
            }
        },
        children:  [
            new LayoutList({
                size:       2,
                focusIndex: 0,
                data:       [
                    {
                        items: [{value: gettext('Yes')}],
                        click: function () {
                            page.modalExit.hide();
                            app.exit();
                        }
                    },
                    {
                        items: [{value: gettext('No')}],
                        click: function () {
                            page.modalExit.hide();
                        }
                    }
                ],
                propagate:  true
            })
        ]
    })
);


// left panel (menu)
page.leftPanel = new Panel({
    title:     gettext('Menu'),
    children:  [],
    className: 'leftPanel'
});

leftPanelContent = [
    {
        items: [{className: 'theme-icon theme-icon-exit', value: ''}, {value: gettext('Exit')}],
        click: function () {
            page.panelSet.blur();
            page.modalExit.show();
        }
    }
];

if ( typeof core.backend.logout === 'function' ) {
    leftPanelContent.unshift({
        items: [
            {className: 'theme-icon theme-icon-logout', value: ''},
            {value: gettext('Logout')}
        ],
        click: showLogOutWarning
    });
}

page.leftPanel.add(
    page.leftPanel.list = new LayoutList({
        cycle:      true,
        focusIndex: 0,
        data:       leftPanelContent
    })
);


// middle panel (list)
page.middlePanel = new Panel({
    title:     [
        {value: gettext('List'), className: 'name'},
        $itemsCountWrapper
    ],
    main:      true,
    children:  [],
    className: 'middlePanel'
});

page.middlePanel.scroll = new ScrollBar({});

page.middlePanel.add(
    page.middlePanel.list = new LayoutList({
        cycle:      true,
        focusIndex: 0,
        size:       7,
        data:       [],
        scroll:     page.middlePanel.scroll,
        events:     {
            'focus:item': function ( data ) {
                page.rightPanel.reset(data);
            }
        },
        noData:     dom.tag(
            'div',
            {className: 'panelHint'},
            dom.tag(
                'div',
                {className: 'hint'},
                dom.tag('div', {className: 'hint', innerHTML: gettext('No data')})
            )
        )
    }),
    page.middlePanel.scroll
);

page.middlePanel.reset = function () {
    var list                  = page.middlePanel.list,
        platformSpecificItems = getDeviceInfo(),
        data                  = [
            {
                items: [
                    {className: 'theme-icon theme-icon-avatar'},
                    {
                        value: gettext('About user'),
                        data: [
                            {type: 'title', data: gettext('User login')},
                            {type: 'text', data: config.user.login},
                            {type: 'title', data: gettext('Account number')},
                            {type: 'text', data: config.user.account},
                            {type: 'title', data: gettext('Tariff')},
                            {type: 'text', data: config.user.tariff}
                        ]
                    }
                ]
            },
            {
                items: [
                    {className: 'theme-icon theme-icon-support'},
                    {
                        value: gettext('Support'),
                        data: [
                            {type: 'title', data: gettext('Call center')},
                            {type: 'html', data: config.support}
                        ]
                    }
                ]
            }
        ];

    if ( platformSpecificItems ) {
        data.splice(1, 0, platformSpecificItems);
    }

    $itemsCount.innerText = data.length;
    list.init({
        data:       data,
        focusIndex: list.$focusItem && list.$focusItem.index ? list.$focusItem.index : 0
    });
};


// right panel (information)
page.rightPanel = new Panel({
    title:     gettext('Details'),
    className: 'rightPanel'
});

page.rightPanel.scroll = new ScrollBar({});

page.rightPanel.textArea = new ScrollArea({
    propagate: true,
    step:      5,
    scroll:    page.rightPanel.scroll
});

page.rightPanel.add(page.rightPanel.textArea, page.rightPanel.scroll);

page.rightPanel.reset = function () {
    var area = page.rightPanel.textArea,
        data = null,
        $fragment, index, $htmlElement;

    area.$body.innerHTML = '';

    if ( page.middlePanel.list.$focusItem && page.middlePanel.list.$focusItem.data ) {
        data = page.middlePanel.list.$focusItem.data.items[1].data;
    }

    if ( data && data.length ) {
        $fragment = dom.fragment();
        for ( index = 0; index < data.length; index++ ) {
            if ( data[index].type === 'title' ) {
                $fragment.appendChild(dom.tag('div', {className: 'title theme-subhead-color'}, data[index].data));
            } else if ( data[index].type === 'text' ) {
                $fragment.appendChild(dom.tag('div', {}, data[index].data));
            } else if ( data[index].type === 'html' ) {
                $htmlElement = document.createElement('div');
                $htmlElement.innerHTML = data[index].data;
                $fragment.appendChild($htmlElement);
            }
        }
        area.$body.appendChild($fragment);
        page.rightPanel.textArea.show();
        page.rightPanel.textArea.init();
    } else {
        page.rightPanel.textArea.hide();
    }
};


// panel set: main
page.add(
    page.panelSet = new PanelSet({
        visible:    true,
        $node:      document.getElementById('panelSetMain'),
        focusIndex: 0,
        panels:     [page.leftPanel, page.middlePanel, page.rightPanel]
    })
);


// listeners
page.addListeners({
    keydown: function ( event ) {
        switch ( event.code ) {
            case keys.back:
                page.panelSet.blur();
                // exit but stay in the task manager
                core.call('stop');
                break;
        }
    },
    show:    function () {
        page.panelSet.show();
        page.panelSet.focus();
        page.middlePanel.reset();

        core.backend.request('profile', {
            version: 3,
            method:  'GET',
            onload:  function ( error, response ) {
                if ( error ) {
                    console.log('ajax error: can\'t get profile');
                    console.log(error);
                    console.log(response);
                } else {
                    config.user.login = response.data.login || '';
                    config.user.account = response.data.account || '';
                    config.user.name = response.data.fname || '';
                    config.user.id = response.data.id || '';
                    config.user.tariff = response.data.tariff_plan || '';
                    config.user.mac = response.data.mac || '';
                    page.middlePanel.reset();
                }
            },
            onerror: function () {
                console.log('ajax error: can\'t get profile');
            }
        });

        core.backend.request('support', {
            version: 3,
            method:  'GET',
            onload:  function ( error, response ) {
                if ( error ) {
                    console.log('ajax error: can\'t get support');
                } else {
                    config.support = response.data;
                    page.middlePanel.reset();
                }
            },
            onerror: function () {
                console.log('ajax error: can\'t get profile');
            }
        });
    }
});

core.addListeners({
    show: page.clock.start,
    hide: page.clock.stop
});


app.route(page);
page.show();


// public
module.exports = page;
